import { Select, Card, Button, Row, Col, notification, Icon, Divider, Empty } from "antd";
import React, { Component } from "react";
import Request, { LAPI_URL } from "../../../request";
import _ from 'lodash';

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const { Option } = Select;

class UniversitySetup extends Component {
    state = {
        countries: [],
        countryArray: [],
        uniArr: [],
        buttonLoading: [],
        courseUniversityIds: {},
        courseUniversityIdsJson: {},
        countryids: [],
        loading: false,
        btnClass: {
            'Save': '#1890ff',
            'Update': '#fa8c16',
            'Processing': '#d8cb15',
            'Completed': '#52c41a'
        },
    }

    loadInitialData = async () => {
        let countryRes = await Request.getCountriesWithoutBusinessAuth({ results: 10000 });
        if (countryRes && !countryRes.error) {
            let countries = []
            let countryArray = [];
            let buttonLoading = [];

            _.each(countryRes.data, (country) => {
                countries.push({
                    _id: country._id,
                    countryName: country.countryName,
                    display: country.countryName
                })
                countryArray[country._id] = country.countryName;
                buttonLoading[country._id] = 'Save';
            })
            let arr = await Request.getAllEveryUniversity({ businessId: '1001' });

            this.setState({ countries, countryArray, buttonLoading, uniArr: arr.arr })
        }
    }

    selectAllUniversitiesByCountry = async (countryId) => {
        let { courseUniversityIds, courseUniversityIdsJson, uniArr } = this.state;
        if (courseUniversityIds[countryId] == undefined) {
            courseUniversityIds[countryId] = [];
        }
        if (courseUniversityIdsJson[countryId] == undefined) {
            courseUniversityIdsJson[countryId] = [];
        }

        // Logical check: determine if we are selecting all or deselecting all
        let unisInCountry = uniArr.filter(u => u.universityCountryId == countryId);
        let allSelected = unisInCountry.every(u => courseUniversityIds[countryId].includes(u._id));

        if (allSelected) {
            // Deselect all for this country
            let idsToRemove = unisInCountry.map(u => u._id);
            courseUniversityIds[countryId] = courseUniversityIds[countryId].filter(id => !idsToRemove.includes(id));
        } else {
            // Select all for this country
            unisInCountry.forEach((uni) => {
                if (!courseUniversityIds[countryId].includes(uni._id)) {
                    courseUniversityIds[countryId].push(uni._id);
                }
            });
        }

        courseUniversityIdsJson[countryId] = courseUniversityIds[countryId].join(',');
        this.setState({ courseUniversityIds, courseUniversityIdsJson });
    }

    selectCountryUniversity = async (countryId, universityId) => {
        let { courseUniversityIds, buttonLoading, courseUniversityIdsJson } = this.state;
        if (courseUniversityIds[countryId] == undefined) {
            courseUniversityIds[countryId] = [];
        }
        if (courseUniversityIdsJson[countryId] == undefined) {
            courseUniversityIdsJson[countryId] = [];
        }
        if (courseUniversityIds[countryId].includes(universityId)) {
            const index = courseUniversityIds[countryId].indexOf(universityId);
            if (index > -1) {
                courseUniversityIds[countryId].splice(index, 1);
            }
        } else {
            courseUniversityIds[countryId].push(universityId);
        }

        if (buttonLoading[countryId] == 'Completed') {
            buttonLoading[countryId] = 'Update';
            this.setState({ buttonLoading })
        }
        courseUniversityIdsJson[countryId] = courseUniversityIds[countryId].join(',');
        this.setState({ courseUniversityIds, courseUniversityIdsJson });
    }

    onNext = () => {
        this.props.onNext();
    }

    onPrev = () => {
        this.props.onPrev();
    }

    saveUniversitySetup = async (countryId) => {
        let courseUniversityIds = this.state.courseUniversityIds[countryId]
        if (!courseUniversityIds || courseUniversityIds.length == 0) {
            return notification.error({
                message: `Please select atleast 1 university.`
            })
        }
        let buttonLoading = this.state.buttonLoading;
        buttonLoading[countryId] = 'Processing';
        this.setState({ buttonLoading })
        let response = await Request.saveUniversitySetup({ universitys: courseUniversityIds });
        if (response && response.error) {
            buttonLoading[countryId] = 'Update';
            this.setState({ buttonLoading })
            return notification.error({
                message: response.msg
            })
        } else {
            buttonLoading[countryId] = 'Completed';
            this.setState({ buttonLoading })
            let countryArray = this.state.countryArray
            let countryName = countryArray[countryId];

            return notification.success({
                message: countryName + ' Institutes setup completed successfully'
            });
        }
    }

    componentDidMount() {
        this.loadInitialData();
    }

    render() {
        let { countries, countryArray, uniArr, buttonLoading, btnClass, loading, courseUniversityIds, countryids } = this.state;
        let { isModal } = this.props;
        return (
            <div className="university-setup-container">
                <style>{`
                    .university-setup-container { padding: 20px 0; }
                    .country-selector-box { background: #fff; padding: 24px; border-radius: 8px; border: 1px solid #e8e8e8; margin-bottom: 30px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
                    .country-selector-box label { display: block; font-weight: 600; margin-bottom: 12px; color: #444; font-size: 14px; }
                    
                    .university-card { border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.05); border: 1px solid #d9d9d9; margin-bottom: 25px; }
                    .university-card .ant-card-head { background: #fafafa; border-bottom: 1px solid #d9d9d9; }
                    .university-card .ant-card-head-title { font-weight: 700; color: #1890ff; }
                    
                    /* ✅ FIXED HEIGHT SCROLLABLE AREA */
                    .university-scroll-container {
                        max-height: 280px; 
                        overflow-y: auto;
                        padding: 10px;
                        margin: 5px 0;
                        border: 1px inset #f0f0f0;
                        background: #fafafa;
                        border-radius: 4px;
                    }
                    /* Scrollbar Styling */
                    .university-scroll-container::-webkit-scrollbar { width: 6px; }
                    .university-scroll-container::-webkit-scrollbar-track { background: #f1f1f1; }
                    .university-scroll-container::-webkit-scrollbar-thumb { background: #1890ff; border-radius: 10px; }

                    .university-grid { display: flex; flex-wrap: wrap; gap: 10px; }
                    .university-item { 
                        padding: 6px 14px; 
                        background: #fff; 
                        border: 1px solid #d9d9d9; 
                        border-radius: 16px; 
                        cursor: pointer; 
                        font-size: 12px; 
                        transition: all 0.2s;
                        color: #555;
                        user-select: none;
                    }
                    .university-item:hover { border-color: #1890ff; color: #1890ff; background: #e6f7ff; }
                    .university-item.active { background: #1890ff; color: #fff; border-color: #1890ff; box-shadow: 0 2px 4px rgba(24, 144, 255, 0.3); }
                    
                    .setup-footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #f0f0f0; display: flex; justify-content: flex-end; }
                    .setup-footer .ant-btn { height: 42px; border-radius: 6px; font-weight: 600; padding: 0 25px; }
                `}</style>

                {/* Country Selection Section */}
                <div className="country-selector-box">
                    <label><Icon type="global" style={{ marginRight: 8, color: '#1890ff' }} />Choose Operational Countries</label>
                    <Select
                        allowClear
                        style={{ width: '100%' }}
                        mode="multiple"
                        showSearch={true}
                        value={this.state.countryids}
                        placeholder="Search and select countries to setup institutes..."
                        optionFilterProp="children"
                        onChange={countryids => this.setState({ countryids })}
                    >
                        {countries.map((val, idn) => (
                            <Option key={idn} value={val._id}>{val.countryName}</Option>
                        ))}
                    </Select>
                </div>

                {/* Universities Section */}
                {countryids && countryids.length > 0 ? (
                    countryids.map((countryId, index) => (
                        <Card
                            className="university-card"
                            title={
                                <span style={{ color: '#fff' }}>
                                    <Icon type="environment" style={{ marginRight: 8, color: '#fff' }} />
                                    {countryArray[countryId]}
                                    <small style={{ marginLeft: 10, color: '#fff', fontWeight: 400, opacity: 0.9 }}>
                                        ({courseUniversityIds[countryId] ? courseUniversityIds[countryId].length : 0} / {uniArr.filter(u => String(u.universityCountryId) === String(countryId)).length} Selected)
                                    </small>
                                </span>
                            }
                            extra={
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <Button
                                        size="small"
                                        onClick={() => this.selectAllUniversitiesByCountry(countryId)}
                                        style={{ borderRadius: '4px' }}
                                    >
                                        <Icon type="select" /> Select/Unselect All
                                    </Button>
                                    <Button
                                        size="small"
                                        type="primary"
                                        style={{ background: btnClass[buttonLoading[countryId]], borderColor: btnClass[buttonLoading[countryId]], borderRadius: '4px' }}
                                        onClick={() => this.saveUniversitySetup(countryId)}
                                        loading={buttonLoading[countryId] === 'Processing'}
                                    >
                                        <Icon type={buttonLoading[countryId] === 'Completed' ? 'check' : 'save'} /> {buttonLoading[countryId]}
                                    </Button>
                                </div>
                            }
                            key={index}
                        >
                            <div className="university-scroll-container">
                                <div className="university-grid">
                                    {uniArr && uniArr.filter(u => u.universityCountryId === countryId).length > 0 ? (
                                        uniArr.map((uni, uIndex) => (
                                            uni.universityCountryId === countryId && (
                                                <div
                                                    key={uIndex}
                                                    onClick={() => this.selectCountryUniversity(countryId, uni._id)}
                                                    className={`university-item ${courseUniversityIds[countryId] && courseUniversityIds[countryId].includes(uni._id) ? 'active' : ''}`}
                                                >
                                                    {uni.universityInstitutionName}
                                                </div>
                                            )
                                        ))
                                    ) : (
                                        <div style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
                                            <Empty description="No universities found for this country" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Card>
                    ))
                ) : (
                    <div style={{ padding: '60px 0', textAlign: 'center', background: '#f9f9f9', borderRadius: '8px' }}>
                        <Icon type="arrow-up" style={{ fontSize: 30, color: '#bfbfbf', marginBottom: 15 }} />
                        <p style={{ color: '#999' }}>Please select at least one country from the dropdown above to manage institutes.</p>
                    </div>
                )}

                {/* Footer Navigation */}
                <div className="setup-footer">
                    {
                        isModal &&
                        <>
                            <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>
                            <Button type="primary" onClick={this.onNext} style={{ height: 40, width: 140 }}>
                                NEXT STEP <Icon type="right" />
                            </Button>
                        </>
                    }
                </div>
            </div>
        )
    }
}

export default UniversitySetup;